const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	favorites:null,
}
const getters = {
	favoritesGetter:({favorites}) => favorites,
}

const mutations = {
	setFavorites : (state,payload) => state.favorites = payload,
	setDeleteFavorites:(state,payload) => {
		if (state.favorites !== null) {
			state.favorites = state.favorites.filter(fav => fav.campus_id !== payload);
		}
	}

}

const actions = {
	async getFavorites({commit}){
		await this.$axios.get(`${BASE_API}/favorite-campuses-ids`).then(res => {
			// Store the full response with favorite_id and campus_id
			commit('setFavorites', res.data.result)
		})
	},
	async createFavorites({commit}, payload){
		const data = {
			favoritable_id: payload.campus_id,
			favoritable_type: 'campus'
		};
		await this.$axios.post(`${BASE_API}/favorites`, data)
	},
	async deleteFavorites({commit, state}, payload){
		$('#loading').show();
		// Find the favorite_id for this campus_id
		const favorite = state.favorites?.find(fav => fav.campus_id === payload.campus_id);
		if (!favorite) {
			$('#loading').hide();
			return;
		}
		
		const data = {
			favoritable_id: payload.campus_id,
			favoritable_type: 'campus'
		};
		await this.$axios.delete(`${BASE_API}/favorites/${favorite.favorite_id}`, {data: data}).then(res => {
			commit('setDeleteFavorites', payload.campus_id)
			$('#loading').hide();
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
